<template>
  <Head title="Login"/>
  <install-app-banner></install-app-banner>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
    <div class="login-card  p-6">
      <div class="w-full max-w-md">
        <logo class="block mx-auto w-full login-card__brand fill-white" height="50"/>
        <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
          <div class="px-10 py-12">
            <h1 class="text-center text-xl md:text-3xl font-bold">{{ __('auth.login.welcome') }}</h1>
            <p class="text-center">Version: {{ config.version }}</p>
            <div class="mt-6 mx-auto w-24 border-b-2"/>
            <alert v-if="$page.props.success" type="success">{{ $page.props.success }}</alert>
            <alert v-if="msg" type="success">{{ msg }}</alert>
            <text-input v-model="form.email" :error="form.errors.email" class="mt-10" :label="__('general.email')"
                        type="email" autofocus autocapitalize="off"
            />
            <text-input v-model="form.password" :error="form.errors.password" class="mt-6" :label="__('general.password')"
                        type="password"
            />
            <label class="flex items-center mt-6 select-none" for="remember">
              <input id="remember" v-model="form.remember" class="mr-1" type="checkbox"/>
              <span class="text-sm">{{ __('auth.login.rememberme') }}</span>
            </label>
          </div>
          <div class="flex items-center px-10 py-4 bg-gray-100 border-t border-gray-100">
            <Link class="text-sm text-primary-500 underline" href="/passwort-vergessen">Passwort vergessen</Link>
            <loading-button :loading="form.processing" class="btn-primary ml-auto" type="submit">
              {{ __('general.login') }}
            </loading-button>
          </div>
        </form>

        <a href="https://www.dgvt-akademie.de/fuer-unsere-pia/dgvt-fuchs/" target="_blank" class="block my-8 relative top-0 hover:-top-1 hover:shadow-2xl transition-all">
          <img src="/img/teaser/240829-loginseite-teaser-fuchsinfo.png" alt="Du möchtest mehr über dne DGVT-Fuchs wissen? - Auf geht's">
        </a>

        <a href="https://www.dgvt.de/der-dgvt-verein/mitglied-werden/" target="_blank" class="block my-8 relative top-0 hover:-top-1 hover:shadow-2xl transition-all">
          <img src="/img/teaser/240829-loginseite-teaser-mitglied.png" alt="Werde als PiA jetzt beitragsfrei Mitglied in DGVT/DGVT-BV">
        </a>
      </div>
    </div>
    <div class="flex text-sm gap-4">
      <dgvt-legal/>
    </div>
  </div>

</template>

<script>

import {Head, Link} from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import InstallAppBanner from '@/Shared/Navigation/InstallAppBanner'
import Alert from '../../Shared/Components/Alert'
import DgvtLegal from '../../Shared/Navigation/DgvtLegal'

export default {

  components: {
    Head,
    LoadingButton,
    Logo,
    TextInput,
    InstallAppBanner,
    Link,
    Alert,
    DgvtLegal,
  },

  props: {
    config: Object,
    msg: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: true,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
